export default __webpack_public_path__ + "img/c213775d26a5ac420dada9bc780bed9d.svg";